import 'css-chunk:src/app/components/Editor/StyleControls/FontControls.module.scss';export default {
  "FontControls": "_FontControls_hj7og_1",
  "fontSelect": "_fontSelect_hj7og_7",
  "sizeSelect": "_sizeSelect_hj7og_11"
};